<template>
	<div style="text-align:center;">
		<el-row :gutter="24">
			<el-col :span="6">
				
					<el-card @click.native="goRedirect('/solicitantes/bandeja')"
					         :body-style="{ padding: '0px' }"
					         class="bg-success text-grey">
							
						<br><br>
						<el-badge :value="newInbox" class="item"><i class="fas fa-address-card"></i>
						</el-badge>
						 
						<p>Bandeja de solicitudes</p>

				
					</el-card>
			</el-col>
			
			<el-col :span="6">
				<el-card @click.native="goRedirect('/becarios/index')"
				         :body-style="{ padding: '0px' }"
				         class="bg-success text-grey">
					<br><br>
					<i class="fas fa-id-card-alt"></i>
					<p>Administración de Becarios</p>
				</el-card>
			</el-col>

			<el-col :span="6">
				<el-card @click.native="goRedirect('/tutores/index')"
				         :body-style="{ padding: '0px' }"
				         class="bg-success text-grey">
					<br><br>
					<i class="fas fa-id-card-alt"></i>
					<p>Administración de Tutores y Responsables</p>
				</el-card>
			</el-col>

			<el-col :span="6">
				<el-card @click.native="goRedirect('/centros-de-trabajo/index')"
				         :body-style="{ padding: '0px' }"
				         class="bg-success text-grey">
					<br><br>
					<i class="fas fa-id-card-alt"></i>
					<p>Administración de Centros de Trabajo</p>
				</el-card>
			</el-col>

		</el-row>
		<br><br>
		<el-row :gutter="24">

			<el-col :span="6">
				<el-card @click.native="goRedirect('/planes-de-capacitacion/index')"
				         :body-style="{ padding: '0px' }"
				         class="bg-success text-grey">
					<br><br>
					<i class="fas fa-id-card-alt"></i>
						<p>Administración de Planes de Capacitación</p>
				</el-card>
			</el-col>

			<el-col :span="6">
				<el-card @click.native="goRedirect('/empresa/index')"
				         :body-style="{ padding: '0px' }"
				         class="bg-success text-grey">
					<br><br>
					<i class="fas fa-building"></i>
					<p>Empresa</p>
				</el-card>
			</el-col>
			<el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
					<el-card @click.native="goRedirect('/correos/mensajes-no-leidos')"
					         :body-style="{ padding: '0px' }"
					         class="bg-success text-grey"
					         shadow="never">
						<div class="text-middle all-padding">
							<i class="fas fa-envelope"></i>
							<p>Mensajes no leidos</p>
						</div>
					</el-card>
			</el-col>
			<el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6" >
					<el-card @click.native="goRedirect('/correos/historico-de-mensajes')"
					         :body-style="{ padding: '0px' }"
					         class="bg-success text-grey"
					         shadow="never">
						<div class="text-middle all-padding">
							<i class="fas fa-envelope-open-text"></i>
							<p>Historico de Mensajes</p>
						</div>
					</el-card>
				</el-col>
			<el-col :span="6">
				&nbsp;
			</el-col>


		</el-row>

	</div>
</template>

<script>

	import {completeAdvisorProfileMix} from '@/mixins/advisor/completeAdvisorProfile';


	export default {

		mixins: [completeAdvisorProfileMix],

		methods: {
			goRedirect(url) {
				this.$router.push(url);
			}
		},
	}
</script>

<style scoped>
	.el-card {
		min-height: 150px;
		cursor: pointer;
	}

	.bg-success {
		background-color: #fdf9f6;
	}

	.text-white {
		color: white
	}

</style>